import { render, staticRenderFns } from "./CombinationProductIndexTwo.vue?vue&type=template&id=f74161da&"
import script from "./CombinationProductIndexTwo.vue?vue&type=script&lang=js&"
export * from "./CombinationProductIndexTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports